import React from 'react';
import { TextField } from '@mui/material';

import { Widget, InlineEditorProps, InlineEditor } from './_InlineDraftEditor';

export function ChipWidget(props: Widget<(string | number)[]>) {
  const values = (props.value ?? []).join(',');

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <TextField
        style={{ width: '120px' }}
        value={values}
        variant="standard"
        autoFocus={true}
        onBlur={props.onBlur}
        onChange={e =>
          props.onValueChange(e.target.value.split(',').map(s => s.trim()))
        }
      />
      <span
        style={{
          fontSize: '12px',
          color: 'var( --c-grey-600)',
          fontStyle: 'italic',
        }}
      >
        Use , as separator
      </span>
    </span>
  );
}

export const ChipInlineEditor = (props: InlineEditorProps<string[]>) => {
  return (
    <InlineEditor
      {...props}
      prettifyFn={chips => chips.join(', ')}
      widget={ChipWidget}
    />
  );
};
